// extracted by mini-css-extract-plugin
export default {"formWrapper":"DoseCard_formWrapper__E-PRy","formInCircle":"DoseCard_formInCircle__XKBgu","formLabel":"DoseCard_formLabel__9xcls","numberInput":"DoseCard_numberInput__yV4cP"};